import useTicket from "@/hooks/useTicket";
import useMundialeChat from "@/hooks/useMundialeChat";
import RechargeFinishedView from "./view";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

export default function RechargeFinished() {
  useMundialeChat();

  const navigate = useNavigate();
  const { 
    isLoading, 
    getTickets, 
    getInvoice, 
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
    customer,
  } = useTicket();

  const [error, setError] = useState<boolean>(false);
  const [shouldProcessTickets, setShouldProcessTickets] = useState<boolean>(false);

  const toggleError = () => setError(prev => !prev);

  const goBack = () => gotToHome();

  const gotToHome = () => navigate("/");

  useEffect(() => {
    if (shouldProcessTickets && customer?.tickets && customer.tickets.length > 0 && !isLoading) {
      setShouldProcessTickets(false);
      openLatestTicket();
    }
  }, [customer?.tickets, shouldProcessTickets, isLoading]);

  const openLatestTicket = () => {
    const currentTickets = customer?.tickets;

    if (!currentTickets || currentTickets.length === 0) {
      toggleError();
      return;
    }

    const [latest] = currentTickets;

    getInvoice({
      id: latest.id,
      date: latest.date,
      price: latest.price,
      status: latest.status,
    });
  };

  const openInvoice = () => {
    setShouldProcessTickets(true);
    getTickets();
  }

  return (
    <RechargeFinishedView
      goBack={goBack}
      gotToHome={gotToHome}
      invoice={invoice}
      toggleModal={toggleModal}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={error}
      toggleError={toggleError}
    />
  );
}
